import React from "react";
import "./skills.scss";

// components
import Wrapper from "../../layouts/wrapper/Wrapper";
import CommonHeader from "../../common/commonHeader/CommonHeader";
import SkillsCard from "../../cards/skillsCard/SkillsCard";

// data
import { frontendSkills, backendSkills } from "../../../assets/data/skillsData";
import LayoutAnimations from "../../animations/LayoutAnimations";

const Skills = () => {
  return (
    <section id="skills">
      <Wrapper>
        <section className="skills">
          <CommonHeader
            title="Here's What We Serve"
            subtitle="Our Services"
            bgText=""
            center={true}
          />

          <div className="skills__container">
            <LayoutAnimations propVarient={"leftToRight"}>
              <SkillsCard
                title={"Our E-Commerce Management & Development Services"}
                icon={"fab fa-react"}
                data={frontendSkills}
              />
            </LayoutAnimations>

            {/* <LayoutAnimations propVarient={"rightToLeft"}>
              <SkillsCard
                title={"Backend"}
                icon={"fab fa-node"}
                data={backendSkills}
              />
            </LayoutAnimations> */}
          </div>
        </section>
      </Wrapper>
    </section>
  );
};

export default Skills;
